'use client';

import { Button, Heading, Icon, Modal, ModalBody, ModalFooter, ModalHeader, TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';

import './styles.scss';

const componentClassname = 'info-modal';

export type InfoModalAction = {
    text: string;
    onClick: () => void;
    loading?: boolean;
    disabled?: boolean;
};

export type InfoModalProps = {
    isActive: boolean;
    title: string;
    text: string;
    onClose: () => void;
    primaryAction: InfoModalAction;
    secondaryAction?: InfoModalAction;
    className?: string;
    closeButtonTestId?: string;
    footerTestId?: string;
};

export function InfoModal({
    isActive,
    title,
    text,
    onClose,
    primaryAction,
    secondaryAction,
    className,
    closeButtonTestId = 'info-modal-close-btn',
    footerTestId = 'info-modal-footer',
}: Readonly<InfoModalProps>) {
    return (
        <Modal dismissible isActive={isActive} className={cn(componentClassname, className)} onClose={onClose}>
            <ModalHeader className={`${componentClassname}__header`} closeButtonText="close">
                <Heading tagName="h5" className={`${componentClassname}__heading`}>
                    {title}
                </Heading>
                <button
                    className="sparky-c-button sparky-c-modal__close-button sparky-c-button--bare sparky-c-button--circle"
                    aria-pressed="true"
                    type="button"
                    onClick={onClose}
                    data-testid={closeButtonTestId}
                >
                    <Icon name="x" />
                </button>
            </ModalHeader>

            <ModalBody className={`${componentClassname}__body`}>
                <TextPassage className={`${componentClassname}__text`}>{text}</TextPassage>
            </ModalBody>

            <ModalFooter data-testid={footerTestId} className={`${componentClassname}__footer`} alignEnd>
                <div className={`${componentClassname}__button-group`}>
                    {secondaryAction ? (
                        <Button
                            type="button"
                            text={secondaryAction.text}
                            onClick={secondaryAction.onClick}
                            loading={secondaryAction.loading}
                            disabled={secondaryAction.disabled || secondaryAction.loading}
                        />
                    ) : null}
                    <Button
                        type="button"
                        variant="primary"
                        text={primaryAction.text}
                        onClick={primaryAction.onClick}
                        loading={primaryAction.loading}
                        disabled={primaryAction.disabled || primaryAction.loading}
                    />
                </div>
            </ModalFooter>
        </Modal>
    );
}
